/* eslint-disable */

import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
 gsap.registerPlugin(ScrollTrigger);

export default function initFixedFirstSection() {
  const firstBlock = document.querySelector('.hero-home');
  if(!firstBlock) return
  const wrap = document.createElement('div');
  let resizeTrigger;
  let oldWidth = window.innerWidth;
  wrap.classList.add('hero-home-wrap');
  firstBlock.parentElement.insertBefore(wrap, firstBlock);
  let scene, trigger, start;

  let mm = gsap.matchMedia();
  let breakPoint = 1024;
  wrap.append(firstBlock);
  

  mm.add(
  {
    // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
    isDesktop: `(min-width: ${breakPoint}px)`,
    isMobile: `(max-width: ${breakPoint - 1}px)`,
    reduceMotion: "(prefers-reduced-motion: reduce)",
  },
  (context) => {
    // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
    let { isDesktop, isMobile, reduceMotion } = context.conditions;

    gsap.set(wrap, {height: firstBlock.clientHeight, position: 'relative'})
    gsap.set(firstBlock, {position: 'absolute', inset: 0})

    function resetBlockFixed() {
      trigger?.kill();
      scene?.kill();
      gsap.set(wrap, {height: ''});
      gsap.set(firstBlock, {position: 'static', inset: ''});
    }

    function setBlockFixed() {
      start = firstBlock.clientHeight >= window.innerHeight ? 'bottom bottom' : 'top top';
      if(isDesktop) {
        gsap.set(wrap, {height: firstBlock.clientHeight, position: 'relative'})
        gsap.set(firstBlock, {position: 'absolute', inset: 0})
      } else {
         gsap.set(wrap, {height: ''});
         gsap.set(firstBlock, {position: 'static', inset: ''});
      }
    }

    function resizeHandler() {
        resetBlockFixed();
        scene = gsap.fromTo(firstBlock, {yPercent: 0}, {yPercent: isDesktop ? 60 : -30, ease: 'none'});
        setBlockFixed();

        trigger = ScrollTrigger.create({
          trigger: firstBlock,
          start,
          end: 'bottom top',
          animation: scene,
          // markers: true,
          scrub: true,
          pin: isDesktop? false : true,
          pinSpacing: false
      });
    }
    resizeHandler();
    window.addEventListener('resize', function() {
      clearTimeout(resizeTrigger);
      resizeTrigger = setTimeout(()=> {
        if(oldWidth === window.innerWidth) return;
        console.log('resize')
        resizeHandler();
        oldWidth = window.innerWidth;
      }, 500);
    });

    return () => {
      // optionally return a cleanup function that will be called when none of the conditions match anymore (after having matched)
      // it'll automatically call context.revert() - do NOT do that here . Only put custom cleanup code here.
    };
  });
}
